export enum EQUERY_KEY {
  TODAY_WORKSHEET_WORKBOOK = 'today-worksheet-workbook',
  PROBLEMS = 'problems',
  BUNDLES = `bundles`,
  BUNDLE_DATES = 'bundle-dates',
  STUDENT_ME = 'student-me',
  STUDENT = 'student',
  ATTENDANCE = 'attendance',
  MY_STUDY_RECORDS = 'my-study-records',
  CREATE_STUDY_RECORD = 'create-study-record',
  TODAY_VOCABULAIRES = 'today-vocabularies',
  TODAY_CLOZE_WORKBOOK = 'today-cloze-workbook',
  TODAY_TEST_WORKBOOK = 'today-test-workbook',
  EXPRESSIONS = 'expressions',
  STORIES = 'stories',
  BOOKMARK_CLOZE_WORKBOOK = 'bookmark-cloze-workbook',
  INCORRECT_NOTE_CLOZE_WORKBOOK = 'incorrect-note-cloze-workbook',
  MY_VOCABULARY_BOOKS = 'my-vocabulary-books',
  MY_VOCABULARY_BOOK_PROGRESS = 'my-vocabulary-book-progress',
  VOCABULARY_WORKBOOK_BOOK = 'vocabulary-workbook-book',
  BOOKMARK_VOCABULARY_WORKBOOK = 'bookmark-vocabulary-workbook',
  INCORRECT_NOTE_VOCABULARY_WORKBOOK = 'incorrect-note-vocabulary-workbook',
  REVIEW_VOCABULARY_WORKBOOK = 'review-vocabulary-workbook',
  CLASSROOM_CHARACTER_GROUPS = 'classroom-character-groups',
  CLASSROOM_CHARACTER_GROUP_WORKBOOKS = 'classroom-character-group-workbooks',
  CLASSROOM_GRAMMARS = 'classroom-grammars',
  SPEAKING_TASKS = 'speaking-tasks',
  SPEAKING_SESSIONS = 'speaking-sessions',
  CLASSROOM_GRAMMAR_WORKBOOKS = 'classroom-grammar-workbooks',
  CLASSROOM_EXPRESSIONS = 'classroom-expressions',
  CLASSROOM_EXPRESSION_WORKBOOKS = 'classroom-expression-workbooks',
  CLASSROOM_CONVERSATIONS = 'classroom-conversations',
  CLASSROOM_CONVERSATION_WORKBOOKS = 'classroom-conversation-workbooks',
}
